// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9800a46b","312":"e46b5d34","551":"dce0a1a0","732":"62f2861f","800":"e56df161","828":"72ec7a61","977":"dcb382a1"}[chunkId] + ".chunk.js";
};